import React, { Component } from 'react';
import { getLocale } from '../../../../Common/Common';

export default class Bill_Header extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		let locale = getLocale(this.props.receiver.lang);
		let df_options = { year: 'numeric', month: 'short', day: 'numeric' };
		let display_from_date = '';
		let display_to_date = '';
		if (this.props.from_date != null) display_from_date = this.props.from_date.toLocaleString(locale, df_options);
		if (this.props.to_date != null) display_to_date = this.props.to_date.toLocaleString(locale, df_options);

		return (
			<div>
				{/* Tenant Name */}
				<span className="tenant-name">{this.props.tenant_name}</span>
				<hr style={{ borderTop: '2px solid #000', marginLeft: 30, marginRight: 30 }}></hr>

				{/* Period */}
				<div className="date-period-content">
					<span className="text">{this.props.receiver.getString('period')}</span>
					<span className="text">: </span>
					<span className="date-period">{display_from_date}</span>
					<span className="text"> - </span>
					<span className="date-period">{display_to_date}</span>
				</div>
			</div>
		)
	}
}